import { v } from "convex/values";

import { internalControl } from "../../../lib/shared/validators";
import { defineTable } from "convex/server";

export const clientExemptDocumentValidator = v.object({
  clientId: v.id("clients"),

  documentConfigId: v.id("invoices_configuration_exempts"),

  fiscalCode: v.optional(v.string()),
  issuedBy: v.optional(v.string()),
  issuedAt: v.optional(v.number()),
  expiresAt: v.optional(v.number()),

  fileId: v.optional(v.id("_storage")),
  fileName: v.optional(v.string()),
  fileType: v.optional(v.string()),
  fileSizeMB: v.optional(v.number()),

  status: v.union(
    v.literal("pending"),
    v.literal("approved"),
    v.literal("rejected"),
    v.literal("expired"),
  ),

  approvedBy: v.optional(v.id("users")),
  approvedAt: v.optional(v.number()),
  rejectionReason: v.optional(v.string()),

  notes: v.optional(v.string()),
  metadata: v.optional(v.record(v.string(), v.any())),

  internalControl,
});

export const clients_exempt_documents = defineTable(
  clientExemptDocumentValidator,
)
  .index("by_client", ["clientId"])
  .index("by_company_id", ["internalControl.companyId"])
  .index("by_company_id_client_id", ["internalControl.companyId", "clientId"])

  .index("by_branch_id", ["internalControl.branchId"])
  .index("by_client_and_status", ["clientId", "status"])
  .index("by_company_and_status", ["internalControl.companyId", "status"])

  .index("by_fiscal_code", ["fiscalCode"])
  .index("by_expiry", ["expiresAt"])
  .index("by_approved_by", ["approvedBy"]);
